import { useContext } from 'react';
import { AuthContext } from '@lp/core/auth';
import { Case, CaseStatus, ServiceType } from '@/api/apis/case';
import { CaseDetailsPermissions } from '@/permissions';
import { isAllowedStatus } from '@/utils/helpers';

export const useDonorPermissions = (caseData: Case) => {
  const { checkPermission } = useContext(AuthContext);
  const hasCasePermission = checkPermission(CaseDetailsPermissions.CaseDonorUpdate);
  const hasAttachmentsReadPermission = checkPermission(CaseDetailsPermissions.CaseAttachmentsRead);
  const hasAttachmentsCreatePermission = checkPermission(CaseDetailsPermissions.CaseAttachmentsCreate);
  const hasAttachmentsUpdatePermission = checkPermission(CaseDetailsPermissions.CaseAttachmentsUpdate);
  const hasAttachmentsDeletePermission = checkPermission(CaseDetailsPermissions.CaseAttachmentsDelete);
  const hasDAPermission = checkPermission(CaseDetailsPermissions.CaseDADonorUpdate);

  const { status, serviceType } = caseData;

  const isDirectAcquisition = serviceType === ServiceType.DirectAcquisition;
  const hasDAEditPermissions = isDirectAcquisition && hasDAPermission;
  const hasEditPermission = hasCasePermission || hasDAEditPermissions;

  const isAttachmentsDisabled =
    !!status &&
    isAllowedStatus({
      currentStatus: status,
      statusFrom: CaseStatus.Finished,
      statusTo: CaseStatus.Closed,
    });

  const disableEditing =
    !isAllowedStatus({ statusTo: CaseStatus.OrganOnOCS, currentStatus: status, prohibitDeclined: true }) ||
    !hasEditPermission;

  return {
    hasEditPermission,
    disableEditing,
    hasAttachmentsReadPermission,
    hasAttachmentsCreatePermission,
    hasAttachmentsUpdatePermission,
    hasAttachmentsDeletePermission,
    isAttachmentsDisabled,
  };
};
